<li class="nav-item">
    <a
    class="bs-nav-link inline-flex items-center font-semibold transition-colors duration-150 hover:text-[var(--navbar-hover-color)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--navbar-hover-color)]"
        (click)="logout()"
    >
    <i class="fa fa-sign-out navbar-action-icon"></i>
    <span class="navbar-action-label">{{'Log Out' | translate: locale | async}}</span>
    </a>
</li>
